module.exports = {"recording.PageTitle":"ECG Recording"}


//////////////////
// WEBPACK FOOTER
// ./src/bundles/en/ekgRecording.json
// module id = 9602
// module chunks = 25